// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__WeXKN","active":"styles_active__POfcn"};